import React, {ReactNode, useEffect, useState} from 'react'
import {FormattedMessage} from 'react-intl'
import { Link } from 'react-router-dom'
import { AreaType, getPrefecture, ListViewType, PrefectureType, UrlPrefix } from '../../config/constants'
import { useLocale } from '../hocs/hooks'
import styles from './AreaPrefectureCollapse.scss'
import DownIcon from '../../assets/imgs/new-vanshare/top/down.svg'
import UpIcon from '../../assets/imgs/new-vanshare/top/up.svg'

const AreaPrefectureCollapse = ({
  serviceType,
  areaIcon,
  area,
  prefectures = [],
  defaultOpen = false
}: {
  serviceType: ListViewType
  areaIcon: ReactNode,
  area: AreaType,
  prefectures: Array<PrefectureType>,
  defaultOpen?: boolean
}) => {
  const locale = useLocale()
  const [open, setOpen] = useState(defaultOpen)
  return <div className={styles.areaItem}>
    <div className={['d-flex align-items-center', styles.areaTitle].join(' ')} onClick={() => setOpen(!open)}>
      {areaIcon}
      <FormattedMessage {...{id: `area.region.${area}`, defaultMessage: `${area}`}} />
      {open
        ? <UpIcon className={['ml-auto'].join(' ')}/>
        : <DownIcon className={['ml-auto'].join(' ')}/>
      }
    </div>
    <div>
      {open && <div className={['align-items-center', styles.prefectureList].join(' ')}>
        <Link
          to={`/${locale}/${UrlPrefix.user}${serviceType === ListViewType.car ? 'car-list' : 'stations'}/${area}/?mode=map`}
        >
          <div key={area} className={[styles.prefectureItem].join(' ')}>
            <div className={[styles.prefectureItemText].join(' ')}>
                {<FormattedMessage {...{id: `area.region.${area}.all`, defaultMessage: `${area}`}} />}
            </div>
          </div>
        </Link>
        {
          prefectures.map(prefecture => <Link
            key={prefecture}
            to={`/${locale}/${UrlPrefix.user}${serviceType === ListViewType.car ? 'car-list' : 'stations'}/${area}/${prefecture}/?mode=map`}
          >
            <div className={[styles.prefectureItem].join(' ')}>
              <div className={[styles.prefectureItemText].join(' ')}>
                  {getPrefecture(locale, prefecture)}
              </div>
            </div>
          </Link>)
        }
      </div>}
    </div>
  </div>
}

AreaPrefectureCollapse.displayName = 'AreaPrefectureCollapse'
export default AreaPrefectureCollapse
